import React from "react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Store } from "lucide-react";
import { useLojas } from "@/hooks/useLojas";

const LojaSelector = ({ lojaSelecionada, onLojaChange, className = "", todasLabel = "Todas as lojas" }) => {
  const lojasDin = useLojas();
  const lojas = ["Todas as lojas", ...lojasDin];

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <Store className="w-4 h-4 text-slate-600" />
      <Select value={lojaSelecionada} onValueChange={onLojaChange}>
        <SelectTrigger className="w-[200px]" data-testid="loja-selector">
          <SelectValue placeholder="Selecione a loja" />
        </SelectTrigger>
        <SelectContent>
          {lojas.map((loja) => (
            <SelectItem key={loja} value={loja}>
              {loja === "Todas as lojas" ? todasLabel : loja}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};

export default LojaSelector;
